import { render } from "./SectionPrivacyNote.vue?vue&type=template&id=b7effd1a&scoped=true"
import script from "./SectionPrivacyNote.vue?vue&type=script&lang=js"
export * from "./SectionPrivacyNote.vue?vue&type=script&lang=js"

import "./SectionPrivacyNote.vue?vue&type=style&index=0&id=b7effd1a&scoped=true&lang=stylus"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b7effd1a"]])

export default __exports__